import React from "react";
import { Input } from "../../Helpers/Input/Input";
import PhoneInput from "react-phone-input-2";
import trans from "../../../utils";

export default function CustomerContact({ addData, show }) {
	return (
		<div className="userinfo">
			<p className="fs-16 fw-700 brand-700 text-uppercase">
				{trans("contact person info")}
			</p>
			<div className="poi-contact-person-info">
				<div className="row">
					<div className="col-lg-6">
						<Input
							title={trans("Name")}
							type="text"
							placeholder={trans("Enter contact name")}
							id="contactPerson.name"
							name="contactPerson.name"
							formstyle="form-input"
							onBlur={(e) => addData.handleBlur(e)}
							onChange={(e) => addData.handleChange(e)}
							value={addData?.values.contactPerson?.name || ""}
							errors={
								addData?.errors?.contactPerson?.name
									? addData?.errors?.contactPerson?.name
									: null
							}
							touched={
								addData?.touched.contactPerson?.name
									? addData?.touched.contactPerson?.name
									: null
							}
						/>
					</div>
					<div className="col-lg-6">
						<div className={`position-relative form-input`}>
							<label className="form-label">{trans("phone number")}</label>
							<div dir="ltr">
								<PhoneInput
									country={"ae"}
									id="contactPerson.phone"
									name="contactPerson.phone"
									inputClass="phone-input"
									containerClass="phone-input-container"
									disableCountryCode
									countryCodeEditable={true}
									enableSearch={true}
									disableSearchIcon
									onBlur={addData.handleBlur}
									onChange={(value) =>
										addData.setFieldValue("contactPerson.phone", value)
									}
									value={addData?.values?.contactPerson?.phone || ""}
									errors={
										addData?.errors?.contactPerson?.phone
											? addData?.errors?.contactPerson.phone
											: null
									}
									touched={
										addData?.touched.contactPerson?.phone
											? addData?.touched?.contactPerson.phone
											: null
									}
								/>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<Input
							title={trans("Email")}
							type="email"
							placeholder={trans("Enter contact email")}
							id="contactPerson.email"
							name="contactPerson.email"
							formstyle="form-input"
							onBlur={(e) => addData.handleBlur(e)}
							onChange={(e) => addData.handleChange(e)}
							errors={
								addData?.errors?.contactPerson?.email
									? addData?.errors?.contactPerson?.email
									: null
							}
							touched={
								addData?.touched.contactPerson?.email
									? addData?.touched.contactPerson?.email
									: null
							}
							value={addData?.values?.contactPerson?.email || ""}
						/>
					</div>
				</div>
			</div>
			<div className="validation">
				{addData?.errors?.contactPerson &&
					show &&
					typeof addData.errors.contactPerson !== "object" &&
					!["name", "email", "phone"].some((key) =>
						addData.errors.contactPerson?.hasOwnProperty?.(key)
					) &&
					addData.errors.contactPerson}
			</div>
		</div>
	);
}
